import React from 'react'
import {
  ConvertLocalTimeGet,
  GetDurationDays,
  GetDurationHours
} from '../../utils'
import {
  Tbody,
  Thead,
  TheadRow,
  TbodyRow,
  TbodyCell,
  TheadCell,
  BlueCell,
  ChildTable,
  Signatories,
  TDSeparator,
  ColorStatus,
  TableWrapper,
  TableChecklist,
  TbodyBorderedRow,
  TaskNameWrapper,
  ActivityNameCell,
  ActivityNameWrapper,
  TableRowWrapperChild,
  TDSeparatorMaterial,
  TbodyCellTotal,
  TbodyRowMaterial
} from './settlement.styled'
import { uniqueId } from 'lodash'

const getStatusColor = (task) => {
  if (task.is_red) return '#E82D2D'
  if (task.is_green) return '#95C123'
  if (task.is_orange) return '#FFB000'
  return '#777777'
}
const getProgressTaskColor = (progressTaskList) => {
  if (progressTaskList.some((detail) => detail.is_red)) return '#E82D2D'
  if (progressTaskList.some((detail) => detail.is_orange)) return '#FFB000'
  if (progressTaskList.every((detail) => detail.is_green)) return '#95C123'
  return '#777777'
}

const renderCargoRows = (cargoList, dataSr) =>
  cargoList?.map((item) => (
    <TbodyRowMaterial key={uniqueId('material-')}>
      <TbodyCell>{item?.product_type}</TbodyCell>
      <TbodyCell>{item?.product_name}</TbodyCell>
      <TbodyCell>{item?.quantity}</TbodyCell>
      <TbodyCell>{item?.uom_quantity}</TbodyCell>
      <TbodyCell>{item?.weight}</TbodyCell>
      <TbodyCell>{item?.uom_weight}</TbodyCell>
      <TbodyCell>{item?.volume}</TbodyCell>
      <TbodyCell>{item?.uom_volume}</TbodyCell>
      <TbodyCell>{item?.material_status}</TbodyCell>
      <TbodyCell>
        {ConvertLocalTimeGet(
          dataSr?.Location,
          item?.material_date,
          'DD/MM/YYYY HH:mm'
        )}
      </TbodyCell>
    </TbodyRowMaterial>
  ))

const renderActivity = (activities, dataSr) => {
  return activities?.map((item, index) => {
    const color = getProgressTaskColor(item.progress_task_header_list)
    return (
      <React.Fragment key={uniqueId('activity-')}>
        <TbodyRow id='total-activity'>
          <ActivityNameCell>
            <ActivityNameWrapper>
              <ColorStatus color={color} />
              {item?.activity_name}
            </ActivityNameWrapper>
          </ActivityNameCell>
          {/* Kosongkan cell lain agar baris utama tetap satu kolom */}
          <TbodyCell colSpan={10}></TbodyCell>
        </TbodyRow>
        {/* Table tambahan di bawah setiap row, tanpa header */}
        {item?.progress_task_header_list?.length > 0 && (
          <TableRowWrapperChild>
            <td colSpan={11}>
              <ChildTable>
                <Tbody>
                  {item.progress_task_header_list.map((task, taskIndex) => {
                    const color = getStatusColor(task)
                    return (
                      <TbodyBorderedRow key={taskIndex}>
                        <TbodyCell width='14%'>
                          <TaskNameWrapper>
                            <ColorStatus color={color} />
                            {task?.task}
                          </TaskNameWrapper>
                        </TbodyCell>
                        <TbodyCell width='6%'>{task?.pic}</TbodyCell>
                        <TbodyCell width='8%'>{task?.level_value}</TbodyCell>
                        <TbodyCell width='9%'>{task?.requirement}</TbodyCell>
                        <TbodyCell width='15%'>
                          {task?.compliance_parameter}
                        </TbodyCell>
                        <TbodyCell width='8%'>
                          {ConvertLocalTimeGet(
                            dataSr?.Location,
                            task?.actual_start_time,
                            'DD/MM/YYYY HH:mm'
                          )}
                        </TbodyCell>
                        <TbodyCell width='8%'>
                          {ConvertLocalTimeGet(
                            dataSr?.Location,
                            task?.actual_finish_time,
                            'DD/MM/YYYY HH:mm'
                          )}
                        </TbodyCell>
                        <TbodyCell width='8%'>{task?.breaktime}</TbodyCell>
                        <TbodyCell width='8%'>{task?.remarks}</TbodyCell>
                        <BlueCell width='8%'>
                          {GetDurationHours(
                            task?.actual_start_time,
                            task?.actual_finish_time
                          ).toFixed(1)}{' '}
                          hours
                        </BlueCell>
                        <BlueCell width='8%'>
                          {GetDurationDays(
                            task?.actual_start_time,
                            task?.actual_finish_time,
                            task?.breaktime
                          )}
                        </BlueCell>
                      </TbodyBorderedRow>
                    )
                  })}
                </Tbody>
                {index !== activities.length - 1 && (
                  <tr>
                    <TDSeparator colSpan={11} />
                  </tr>
                )}
              </ChildTable>
            </td>
          </TableRowWrapperChild>
        )}
      </React.Fragment>
    )
  })
}

const ChecklistModalContent = ({ dataPrint, dataSr }) => {
  const [materialVolume] = dataPrint.cargoTotal.volume ?? []
  const [materialWeight] = dataPrint.cargoTotal.weight ?? []

  return (
    <TableWrapper>
      <TableChecklist>
        <Thead>
          <TheadRow>
            <TheadCell width='14%'>Description</TheadCell>
            <TheadCell width='6%'>PIC</TheadCell>
            <TheadCell width='8%'>Level</TheadCell>
            <TheadCell width='9%'>Requirement</TheadCell>
            <TheadCell width='15%'>Compliance Parameter</TheadCell>
            <TheadCell width='8%'>Start</TheadCell>
            <TheadCell width='8%'>Finish</TheadCell>
            <TheadCell width='8%'>Breaktime</TheadCell>
            <TheadCell width='8%'>Remarks</TheadCell>
            <TheadCell width='8%'>Duration in Hours</TheadCell>
            <TheadCell width='8%'>Duration in Days</TheadCell>
          </TheadRow>
        </Thead>
        <Tbody>{renderActivity(dataPrint?.activityList, dataSr)}</Tbody>
      </TableChecklist>
      {dataPrint?.cargoList?.length > 0 && (
        <TableChecklist style={{ border: 'none' }}>
          <Thead>
            <TheadRow>
              <TheadCell>Material</TheadCell>
              <TheadCell>Detail</TheadCell>
              <TheadCell>Qty</TheadCell>
              <TheadCell>UOM Qty</TheadCell>
              <TheadCell>Weight</TheadCell>
              <TheadCell>UOM Weight</TheadCell>
              <TheadCell>Volume</TheadCell>
              <TheadCell>UOM Volume</TheadCell>
              <TheadCell>Material Status</TheadCell>
              <TheadCell>Material Date</TheadCell>
            </TheadRow>
          </Thead>
          <Tbody>
            {renderCargoRows(dataPrint?.cargoList, dataSr)}
            <TbodyRowMaterial>
              <TDSeparatorMaterial colSpan={10} />
            </TbodyRowMaterial>
            <TbodyRowMaterial>
              <TbodyCellTotal colSpan={2}>Total</TbodyCellTotal>
              <TbodyCell colSpan={2}></TbodyCell>
              <TbodyCell>{materialWeight?.total_weight}</TbodyCell>
              <TbodyCell>{materialWeight?.uom_weight}</TbodyCell>
              <TbodyCell>{materialVolume?.total_volume}</TbodyCell>
              <TbodyCell colSpan={3}>{materialVolume?.uom_volume}</TbodyCell>
            </TbodyRowMaterial>
          </Tbody>
        </TableChecklist>
      )}
      <TableChecklist>
        <thead>
          <TheadRow>
            <TheadCell width='40%'>Approver Name</TheadCell>
            <TheadCell width='60%'>Signatories</TheadCell>
          </TheadRow>
        </thead>
        <tbody>
          {dataPrint.Settlement_Approval?.map((item) => (
            <TbodyRow key={uniqueId('approval-')}>
              <TbodyCell>{item?.Confirmer_Name}</TbodyCell>
              <TbodyCell>
                <Signatories>
                  <span>Digital Signed By {item?.Confirmer_Name}</span>
                  <span>
                    Date :
                    {ConvertLocalTimeGet(
                      dataSr?.Location,
                      item?.Confirmer_Date,
                      'DD-MM-YYYY HH:mm'
                    )}
                  </span>
                </Signatories>
              </TbodyCell>
            </TbodyRow>
          ))}
        </tbody>
      </TableChecklist>
    </TableWrapper>
  )
}

export default ChecklistModalContent
